import React from "react";
import { Chip, makeStyles } from "@material-ui/core";
import locale from "@bonliva-crm/locale";

export const NationellaChip = () => {
  const classes = useStyles({});

  return (
    <Chip
      variant="outlined"
      label={locale.NationalProcurementShort}
      className={classes.chip}
    />
  );
};

const useStyles = makeStyles({
  chip: {
    height: 24,
    backgroundColor: "#ecff00",
    color: "#1400fd",
    borderColor: "#1400fd",
    marginLeft: 4,

    "& span": {
      paddingLeft: 8,
      paddingRight: 8
    },

    "& > div": {
      backgroundColor: "transparent !important"
    }
  }
});

export default NationellaChip;
